// src/services/geoLocationService.js
import axios from 'axios';

const geoLocationService = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const getCountries = () => {
    return geoLocationService.get('/geo/countries');
};

export const getStates = () => {
    return geoLocationService.get('/locations/states');
};

export const getCities = (state_code) => {
    return geoLocationService.get(`/locations/cities/${state_code}`);
};

export const getZipcodes = (state_code,city) => {
    return geoLocationService.get(`/locations/zipcodes/${state_code}/${city}`);
};

export default geoLocationService;
